// extracted by mini-css-extract-plugin
module.exports = {"subheading":"ConnectedAccounts_subheading__39cp0","divider":"ConnectedAccounts_divider__1RoTc"};